import {
    FolderOutput,
    ChevronsUpDown,
    Loader,
  } from "lucide-react";
  import React, { useState } from "react";
  import MessageModal from "../Modal/MessageModal";
  import CreateOrderModal from "../Modal/CreateOrderModal";
  import OrderSingleViewModal from "../Modal/OrderSingleViewModal";
  import { all_insurance_options } from "../../helpers";
  import BulkMessageSendModal from "../Modal/BulkMessageSendModal";
  import Badge from '../UI/Badge';
import Skeleton from "react-loading-skeleton";

  
  const styles = {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    cursor: "pointer",
  };
  
  export default function OrderDataTable(props) {
    const {
      tableData = [],
      handleCheckboxChange = () => {},
      handleSelectAll = () => {},
      selectAll = false,
      checkedIds = [],
      checkSelected = false,
      handleAddToWaitingRoom = () => {},
      handleSignOutSheet = () => {},
      reloadData = () => {},
      reloadDataFilter = {},
      messageTemplate = [],
      scanList = [],
      handlePatientStatus = () => {},
      user_id,
      account_id,
      location_id,
      smsLimit,
      setSmsLimit = () => {},
      dataLoading,
      setDataLoading = () => {},
      exportData = () => {},
      buttonLoader = false
    } = props;
    

  
    // const sendBulkSms = () => {
    //   console.log(getTableIdToContents("bulk", checkedIds));
    // };
    const [insuranceOptions] = useState(all_insurance_options());
    const [activePatientViewModal, setActivePatientViewModal] = useState(false);
    const [activeOrderViewModal, setActiveOrderViewModal] = useState(false);
    const [activeModal, setActiveModal] = useState(false);
    const [activeCreateOrderModal, setActiveOrderModal] = useState(false);  
    const [patientData, setPatientData] = useState({});
    const [orderData, setOrderData] = useState({});
    const [orderBy, setOrderBy] = useState();
    const [previousScrollPosition, setPreviousScrollPosition] = useState(0);

    const handleOrderChange = (name, type = "asc") => {
      name = name.toString();
      setOrderBy(name);
      if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
        if (reloadDataFilter.order_by[1] == "asc") {
          type = "desc";
        }
      }
      const orderFilter = { order_by: [name, type.toString()] };
      const filter_merge = { ...reloadDataFilter, ...orderFilter };
      setDataLoading(true);
      reloadData(filter_merge);
    };
  
    const handleSendMessageModal = (data) => {
      setPatientData(data)
      setActiveModal(!activeModal);
      setPreviousScrollPosition(window.scrollY);
      window.scrollTo(0, 0);
    }
  
    const handleCreateOrderModal = (data) => {
      setPatientData(data)
      setActiveOrderModal(!activeCreateOrderModal);
      setPreviousScrollPosition(window.scrollY);
      window.scrollTo(0, 0);
    }
  
    const handlePatientViewModal = (data) => {
      setPatientData(data);
      setActivePatientViewModal(!activePatientViewModal);
      setPreviousScrollPosition(window.scrollY);
      window.scrollTo(0, 0);
    }

    const handleOrderViewModal = (data) => {
      setOrderData(data);
      setActiveOrderViewModal(!activeOrderViewModal);
      setPreviousScrollPosition(window.scrollY);
      window.scrollTo(0, 0);
    }
  

    const getStatusBadge = (status) => {
      switch (status) {
        case 'Completed':
          return <Badge color="green">Completed</Badge>;
        case 'In-Progress':
          return <Badge color="yellow">In Progress</Badge>;
        default:
          return <Badge color="grey">{status}</Badge>;
      }
    };
  
    return (
      <>
        {checkSelected && (
          <>
            <hr />
            <div className="docpro_data_table_btns">
              <BulkMessageSendModal
                checkedIds={checkedIds}
                messageTemplate={messageTemplate}
                account_id={account_id}
                location_id={location_id}
                smsLimit={smsLimit}
                setSmsLimit={setSmsLimit}
              />
              {/* <button className="docpro_bordered_btn docpro_fw_600 docpro_primary_color" onClick={sendBulkSms}>
                <MessageSquareShare width={20} height={20} />
                Send Bulk SMS
              </button> */}
              <button 
                className="docpro_bordered_btn docpro_fw_600 docpro_primary_color"
                onClick={exportData}
                disabled = {buttonLoader ? true : false}
              >
                <FolderOutput width={20} height={20} />
                Export All
                {buttonLoader && (
                  <span className="docpro_loading">
                    <Loader width={20} height={20} />
                  </span>
                )}
              </button>
              {/* <button className="docpro_bordered_btn docpro_fw_600 docpro_red_color">
                <Trash2 width={20} height={20} />
                Delete
              </button> */}
              <select className="docpro_form_field size_lg docpro_fw_600" name='status' onChange={handlePatientStatus} style={{ maxWidth: '150px', height: '36px' }} >
                <option >Change Status</option>
                <option value="1">Active</option>
                <option value="2">Inactive</option>
              </select>
            </div>
          </>
        )}
        <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
          <table className="docpro_mb_0" style={{ height: "100%" }}>
            <thead>
              <tr>
                <th style={{ width: "45px" }}>
                  <div className="docpro_checkbox" style={{ top: "3px" }}>
                    <input
                      type="checkbox"
                      checked={tableData.length > 0 && selectAll}
                      onChange={handleSelectAll}
                      disabled={tableData.length === 0}
                    />
                    <label></label>
                  </div>
                </th>
                <th>
                  <div style={styles}>
                    Last Name
                  </div>
                </th>
                <th>
                  <div>
                    <div style={styles}>
                      First Name
                    </div>
                  </div>
                </th>
                <th
                  onClick={() => {
                    handleOrderChange("medmo_order_id");
                  }}
                  className={orderBy === "medmo_order_id" ? "docpro_accent_color" : ""}
                >
                  <div style={styles}>
                    Medmo Order Id <ChevronsUpDown size={"12"} />
                  </div>
                </th>
                <th
                  onClick={() => {
                    handleOrderChange("medmo_scan_id");
                  }}
                  className={orderBy === "medmo_scan_id" ? "docpro_accent_color" : ""}
                >
                  <div style={styles}>
                  Medmo Scan Id <ChevronsUpDown size={"12"} />
                  </div>
                </th>
                <th>
                
                  <div style={styles}>
                    Insurance Plan 
                  </div>
                </th>
                <th
                  onClick={() => {
                    handleOrderChange("policy_number");
                  }}
                  className={orderBy === "policy_number" ? "docpro_accent_color" : ""}
                >
                  <div style={styles}>
                  Policy Number <ChevronsUpDown size={"12"} />
                  </div>
                </th>
                <th
                  onClick={() => {
                    handleOrderChange("group_number");
                  }}
                  className={orderBy === "group_number" ? "docpro_accent_color" : ""}
                >
                  <div style={styles}>
                  Group Number <ChevronsUpDown size={"12"} />
                  </div>
                </th>
                
                <th
                  onClick={() => {
                    handleOrderChange("icd10");
                  }}
                  className={
                    orderBy === "icd10" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                  ICD10 <ChevronsUpDown size={"12"} />
                  </div>
                </th>
                <th
                  onClick={() => {
                    handleOrderChange("exam_reason");
                  }}
                  className={orderBy === "exam_reason" ? "docpro_accent_color" : ""}
                >
                  <div style={styles}>
                  Exam Reason <ChevronsUpDown size={"12"} />
                  </div>
                </th>
                
                
                <th
                  
                >
                  <div style={styles}>
                  Status 
                  </div>
                </th>
                
              </tr>
            </thead>
            <tbody>
              {!dataLoading ? (
                tableData.length > 0 ? (
                  tableData?.map((item, index) => (
                    <tr key={index} className={`row_${item.id} pointer`}>
                      <td style={{ width: "45px" }}>
                        <div className="docpro_checkbox" style={{ top: "3px" }}>
                          <input
                            type="checkbox"
                            checked={item.checked || false}
                            onChange={() => handleCheckboxChange(item.id)}
                          />
                          <label></label>
                        </div>
                      </td>
  
                      <td className="bulk" onClick={() => handleOrderViewModal(item)}>
                        {/* <img
                          src={item.avatarImgUrl}
                          alt=""
                          width={28}
                          height={28}
                          style={{
                            marginRight: "10px",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        /> */}
                        {item.lastName}
                      </td>
  
                      <td className="bulk" onClick={() => handleOrderViewModal(item)}>
                        {item.firstName}
                      </td>
  
                      <td onClick={() => handleOrderViewModal(item)}>
                        {item.medmoOrderId}
                      </td>
                      <td onClick={() => handleOrderViewModal(item)}>
                        {item.medmoScanId}
                      </td>
                      <td className="bulk" onClick={() => handleOrderViewModal(item)}>
                        {item.insurancePlan}
                      </td>
                      <td onClick={() => handleOrderViewModal(item)}>
                        {item.policyNumber}
                      </td>
                      <td onClick={() => handleOrderViewModal(item)}>
                        {item.groupNumber}
                      </td>
                      <td onClick={() => handleOrderViewModal(item)}>
                        {item.icd10}
                      </td>
                      <td onClick={() => handleOrderViewModal(item)}>
                        {item.examReason}
                      </td>
                      <td className="bulk hidden">
                        {item.id}
                      </td>
                     
                      <td onClick={() => handleOrderViewModal(item)}>
                        {getStatusBadge(item.status)}
                      </td>

                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="11">
                      No data available
                    </td>
                  </tr>
                )
              ) : (
                Array.from({ length: 8 }).map((_, index) => (
                  <tr key={index} style={{ height: '50px' }}>
                    <td style={{ width: "45px" }}> <Skeleton width="1.2rem" borderRadius="8px"></Skeleton> </td>
                    <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                    <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                    <td> <Skeleton width={`${3 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                    <td> <Skeleton width={`${2 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                    <td> <Skeleton width={`${5 + (index % 2.8)}rem`} borderRadius="8px"></Skeleton> </td>
                    <td> <Skeleton width={`${3 + (index % 2.8)}rem`} borderRadius="8px"></Skeleton> </td>
                    <td> <Skeleton width={`${2.5 + (index % 3.5)}rem`} borderRadius="8px"></Skeleton> </td>
                    <td> <Skeleton width={`${3 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                    <td> <Skeleton width={`${4 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                    <td> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
  
        {activeModal && (
          <MessageModal
            patient_id={patientData.id}
            last_name={patientData.lastName}
            first_name={patientData.firstName}
            phone={patientData.mobilePhone}
            messageTemplate={messageTemplate}
            tooltip={true}
            account_id={account_id}
            location_id={location_id}
            activeModal={activeModal}
            setActiveModal={setActiveModal}
            setSmsLimit={setSmsLimit}
            previousScrollPosition={previousScrollPosition}
          />
        )}
    
        {activeCreateOrderModal && (
          <CreateOrderModal
            last_name={patientData.lastName}
            first_name={patientData.firstName}
            phone={patientData.mobilePhone}
            scanList={scanList}
            tooltip={true}
            patient_id = {patientData.id}
            insurance_name = {patientData.insuranceName}
            insurance_code = { patientData.insuranceID}
            user_id = {user_id}
            account_id={account_id}
            location_id={location_id}
            activeModal={activeCreateOrderModal}
            setActiveModal={setActiveOrderModal}
            setSmsLimit={setSmsLimit}
            previousScrollPosition={previousScrollPosition}
          />
        )}
        
        {activeOrderViewModal && (
          <OrderSingleViewModal
            user_id={user_id}
            order_id={orderData.id}
            medmo_order_id = {orderData.medmoOrderId}
            reloadData={reloadData}
            reloadDataFilter={reloadDataFilter}
            messageTemplate={messageTemplate}
            account_id={account_id}
            location_id={location_id}
            insuranceOptions={insuranceOptions}
            activeModal={activeOrderViewModal}
            setActiveModal={setActiveOrderViewModal}
            setSmsLimit={setSmsLimit}
            previousScrollPosition={previousScrollPosition}
          />
        )}
      </>
    );
  }
  